module.exports = __webpack_public_path__ + "img/flying_dutchman.f374d271.jpg";